module.exports = __webpack_public_path__ + "static/assets/2a21e7375a52fcd5fa33ddab3b1fd56b.png";